import AlertIcon from "./line/Alert.svg?react";
import AlertTriangleIcon from "./line/AlertTriangle.svg?react";
import ArrowDownIcon from "./line/ArrowDown.svg?react";
import ArrowLeftIcon from "./line/ArrowLeft.svg?react";
import ArrowRightIcon from "./line/ArrowRight.svg?react";
import ArrowsUpIcon from "./line/ArrowsUp.svg?react";
import ArrowUpIcon from "./line/ArrowUp.svg?react";
import AsteriskIcon from "./line/Asterisk.svg?react";
import BarChartIcon from "./line/BarChart.svg?react";
import BookIcon from "./line/Book.svg?react";
import BoldIcon from "./line/Bold.svg?react";
import BulletListIcon from "./line/BulletList.svg?react";
import CalendarIcon from "./line/Calendar.svg?react";
import ChatCircleIcon from "./line/ChatCircle.svg?react";
import CheckCircleIcon from "./line/CheckCircle.svg?react";
import CheckIcon from "./line/Check.svg?react";
import ChevronDownIcon from "./line/ChevronDown.svg?react";
import ChevronLeftIcon from "./line/ChevronLeft.svg?react";
import ChevronRightIcon from "./line/ChevronRight.svg?react";
import ChevronSelectorIcon from "./line/ChevronSelector.svg?react";
import ChevronUpIcon from "./line/ChevronUp.svg?react";
import ClipboardIcon from "./line/Clipboard.svg?react";
import CloseIcon from "./line/Close.svg?react";
import CodeIcon from "./line/Code.svg?react";
import CoinsIcon from "./line/Coins.svg?react";
import CompassIcon from "./line/Compass.svg?react";
import CopyIcon from "./line/Copy.svg?react";
import CornerDownLeftIcon from "./line/CornerDownLeft.svg?react";
import DotIcon from "./line/Dot.svg?react";
import DotsVerticalIcon from "./line/DotsVertical.svg?react";
import DownloadIcon from "./line/Download.svg?react";
import DragHandleIcon from "./line/DragHandle.svg?react";
import EditIcon from "./line/Edit.svg?react";
import ExpandIcon from "./line/Expand.svg?react";
import EyeIcon from "./line/Eye.svg?react";
import FileEditIcon from "./line/FileEdit.svg?react";
import FileIcon from "./line/File.svg?react";
import FilterIcon from "./line/Filter.svg?react";
import FlagIcon from "./line/Flag.svg?react";
import HashIcon from "./line/Hash.svg?react";
import HeadingIcon from "./line/Heading.svg?react";
import Heading2Icon from "./solid/Heading2.svg?react";
import Heading3Icon from "./solid/Heading3.svg?react";
import Heading4Icon from "./solid/Heading4.svg?react";
import HelpIcon from "./line/Help.svg?react";
import ImageIcon from "./line/Image.svg?react";
import InfoIcon from "./line/Info.svg?react";
import InfoSquareIcon from "./line/InfoSquare.svg?react";
import ItalicIcon from "./line/Italic.svg?react";
import LayersIcon from "./line/Layers.svg?react";
import LayoutIcon from "./line/Layout.svg?react";
import LinkExternalIcon from "./line/LinkExternal.svg?react";
import LinkIcon from "./line/Link.svg?react";
import LoadingIcon from "./line/Loading.svg?react";
import LogOutIcon from "./line/LogOut.svg?react";
import MagicWandIcon from "./line/MagicWand.svg?react";
import MailIcon from "./line/Mail.svg?react";
import MessageChatSquareIcon from "./line/MessageChatSquare.svg?react";
import MessageDotsSquareIcon from "./line/MessageDotsSquare.svg?react";
import MessageSmileIcon from "./line/MessageSmile.svg?react";
import MessageTextSquareIcon from "./line/MessageTextSquare.svg?react";
import MinusCircleIcon from "./line/MinusCircle.svg?react";
import MinusIcon from "./line/Minus.svg?react";
import NumberListIcon from "./line/NumberList.svg?react";
import ParagraphIcon from "./solid/Paragraph.svg?react";
import PerspectiveIcon from "./line/Perspective.svg?react";
import PinIcon from "./line/Pin.svg?react";
import PlayCircleIcon from "./line/PlayCircle.svg?react";
import PlusCircleIcon from "./line/PlusCircle.svg?react";
import PlusIcon from "./line/Plus.svg?react";
import RefreshIcon from "./line/Refresh.svg?react";
import RepeatIcon from "./line/Repeat.svg?react";
import RowsIcon from "./line/Rows.svg?react";
import SearchIcon from "./line/Search.svg?react";
import SendIcon from "./line/Send.svg?react";
import SettingsIcon from "./line/Settings.svg?react";
import ShoppingCartIcon from "./line/ShoppingCart.svg?react";
import SlashCircleIcon from "./line/SlashCircle.svg?react";
import SpeedometerIcon from "./line/Speedometer.svg?react";
import StepIconCheckIcon from "./line/StepIconCheck.svg?react";
import StepIconIcon from "./line/StepIcon.svg?react";
import StrikethroughIcon from "./line/Strikethrough.svg?react";
import TagIcon from "./line/Tag.svg?react";
import TargetIcon from "./line/Target.svg?react";
import TextInputIcon from "./line/TextInput.svg?react";
import ThumbsDownIcon from "./line/ThumbsDown.svg?react";
import ThumbsUpIcon from "./line/ThumbsUp.svg?react";
import TrashIcon from "./line/Trash.svg?react";
import TrendUpIcon from "./line/TrendUp.svg?react";
import TypeIcon from "./line/Type.svg?react";
import UnderlineIcon from "./line/Underline.svg?react";
import UserIcon from "./line/User.svg?react";
import UsersIcon from "./line/Users.svg?react";
import UsersPlusIcon from "./line/UsersPlus.svg?react";
import VariableIcon from "./line/Variable.svg?react";
import ZapIcon from "./line/Zap.svg?react";

import SolidChatIcon from "./solid/Chat.svg?react";
import SolidCogIcon from "./solid/Cog.svg?react";
import SolidFlashIcon from "./solid/Flash.svg?react";
import SolidScriptIcon from "./solid/Script.svg?react";
import SolidSendIcon from "./solid/Send.svg?react";
import SolidStarsIcon from "./solid/Stars.svg?react";

import styles from "./Icon.module.css";
import classNames from "classnames";
import { forwardRef } from "react";

export type IconSize = "xxsmall" | "xsmall" | "small" | "medium" | "large";

interface IconProps {
  className?: string;
  size?: IconSize;
}

const getSize = (size: IconSize) => {
  switch (size) {
    case "xxsmall":
      return styles.iconXxsmall;
    case "xsmall":
      return styles.iconXsmall;
    case "small":
      return styles.iconSmall;
    case "medium":
      return styles.iconMedium;
    case "large":
      return styles.iconLarge;
    default:
      return undefined;
  }
};

export type IconComponentType = React.FunctionComponent<IconProps>;

const withIcon = (
  SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
  line = false,
) => {
  return forwardRef<HTMLSpanElement, IconProps>(function IconComponent(
    { className, size = "small", ...props },
    ref,
  ) {
    return (
      <span className={className} {...props} ref={ref}>
        <SvgComponent
          className={classNames(getSize(size), {
            [styles.icon]: !line,
            [styles.oldIcon]: line,
          })}
        />
      </span>
    );
  });
};

export const Alert = withIcon(AlertIcon, true);
export const AlertTriangle = withIcon(AlertTriangleIcon, true);
export const ArrowDown = withIcon(ArrowDownIcon, true);
export const ArrowLeft = withIcon(ArrowLeftIcon, true);
export const ArrowRight = withIcon(ArrowRightIcon, true);
export const ArrowsUp = withIcon(ArrowsUpIcon, true);
export const ArrowUp = withIcon(ArrowUpIcon, true);
export const BarChart = withIcon(BarChartIcon, true);
export const Book = withIcon(BookIcon, true);
export const Bold = withIcon(BoldIcon, true);
export const BulletList = withIcon(BulletListIcon, true);
export const Calendar = withIcon(CalendarIcon, true);
export const ChatCircle = withIcon(ChatCircleIcon, true);
export const Check = withIcon(CheckIcon, true);
export const CheckCircle = withIcon(CheckCircleIcon, true);
export const ChevronDown = withIcon(ChevronDownIcon, true);
export const ChevronLeft = withIcon(ChevronLeftIcon, true);
export const ChevronRight = withIcon(ChevronRightIcon, true);
export const ChevronSelector = withIcon(ChevronSelectorIcon, true);
export const ChevronUp = withIcon(ChevronUpIcon, true);
export const Clipboard = withIcon(ClipboardIcon, true);
export const Close = withIcon(CloseIcon, true);
export const Code = withIcon(CodeIcon, true);
export const Coins = withIcon(CoinsIcon, true);
export const Compass = withIcon(CompassIcon, true);
export const Copy = withIcon(CopyIcon, true);
export const CornerDownLeft = withIcon(CornerDownLeftIcon, true);
export const Dot = withIcon(DotIcon, true);
export const DotsVertical = withIcon(DotsVerticalIcon, true);
export const Download = withIcon(DownloadIcon, true);
export const DragHandle = withIcon(DragHandleIcon, true);
export const Edit = withIcon(EditIcon, true);
export const Expand = withIcon(ExpandIcon, true);
export const Eye = withIcon(EyeIcon, true);
export const File = withIcon(FileIcon, true);
export const FileEdit = withIcon(FileEditIcon, true);
export const Filter = withIcon(FilterIcon, true);
export const Flag = withIcon(FlagIcon, true);
export const Hash = withIcon(HashIcon, true);
export const Heading = withIcon(HeadingIcon, true);
export const Heading2 = withIcon(Heading2Icon, false);
export const Heading3 = withIcon(Heading3Icon, false);
export const Heading4 = withIcon(Heading4Icon, false);
export const Help = withIcon(HelpIcon, true);
export const Image = withIcon(ImageIcon, true);
export const Info = withIcon(InfoIcon, true);
export const InfoSquare = withIcon(InfoSquareIcon, true);
export const Italic = withIcon(ItalicIcon, true);
export const Layers = withIcon(LayersIcon, true);
export const Layout = withIcon(LayoutIcon, true);
export const Link = withIcon(LinkIcon, true);
export const LinkExternal = withIcon(LinkExternalIcon, true);
export const Loading = withIcon(LoadingIcon, true);
export const LogOut = withIcon(LogOutIcon, true);
export const MagicWand = withIcon(MagicWandIcon, true);
export const Mail = withIcon(MailIcon, true);
export const MessageChatSquare = withIcon(MessageChatSquareIcon, true);
export const MessageDotsSquare = withIcon(MessageDotsSquareIcon, true);
export const MessageSmile = withIcon(MessageSmileIcon, true);
export const MessageTextSquare = withIcon(MessageTextSquareIcon, true);
export const Minus = withIcon(MinusIcon, true);
export const MinusCircle = withIcon(MinusCircleIcon, true);
export const NumberList = withIcon(NumberListIcon, true);
export const Paragraph = withIcon(ParagraphIcon, false);
export const Perspective = withIcon(PerspectiveIcon, true);
export const Pin = withIcon(PinIcon, true);
export const PlayCircle = withIcon(PlayCircleIcon, true);
export const Plus = withIcon(PlusIcon, true);
export const PlusCircle = withIcon(PlusCircleIcon, true);
export const Refresh = withIcon(RefreshIcon, true);
export const Repeat = withIcon(RepeatIcon, true);
export const Rows = withIcon(RowsIcon, true);
export const Search = withIcon(SearchIcon, true);
export const Send = withIcon(SendIcon, true);
export const Settings = withIcon(SettingsIcon, true);
export const ShoppingCart = withIcon(ShoppingCartIcon, true);
export const SlashCircle = withIcon(SlashCircleIcon, true);
export const Speedometer = withIcon(SpeedometerIcon, true);
export const StepIcon = withIcon(StepIconIcon, true);
export const StepIconCheck = withIcon(StepIconCheckIcon, true);
export const Strikethrough = withIcon(StrikethroughIcon, true);
export const Tag = withIcon(TagIcon, true);
export const Target = withIcon(TargetIcon, true);
export const TextInput = withIcon(TextInputIcon, true);
export const ThumbsDown = withIcon(ThumbsDownIcon, true);
export const ThumbsUp = withIcon(ThumbsUpIcon, true);
export const Trash = withIcon(TrashIcon, true);
export const TrendUp = withIcon(TrendUpIcon, true);
export const Type = withIcon(TypeIcon, true);
export const Underline = withIcon(UnderlineIcon, true);
export const User = withIcon(UserIcon, true);
export const Users = withIcon(UsersIcon, true);
export const UsersPlus = withIcon(UsersPlusIcon, true);
export const Variable = withIcon(VariableIcon, true);
export const Zap = withIcon(ZapIcon, true);

export const Asterisk = withIcon(AsteriskIcon);
export const SolidChat = withIcon(SolidChatIcon);
export const SolidCog = withIcon(SolidCogIcon);
export const SolidFlash = withIcon(SolidFlashIcon);
export const SolidScript = withIcon(SolidScriptIcon);
export const SolidSend = withIcon(SolidSendIcon);
export const SolidStars = withIcon(SolidStarsIcon);
